module.exports = __webpack_public_path__ + "img/Phone-4.481b3357.png";